import { VuexState, UsersList, User } from '@/common/Users';

import axios from 'axios';
import uuid from 'uuid/v4';

const state: VuexState = {
	users: [],
	user: undefined,
	incompleteUsers: [],
};

const getters = {
	user: (state: VuexState) => state.user,
};

const mutations = {
	setAllUsers(state: VuexState, payload: UsersList[]): void {
		state.users = payload;
	},
	setUser(state: VuexState, payload: User): void {
		state.user = payload;
	},
	setIncompleteUsers(state: VuexState, payload: any[]): void {
		state.incompleteUsers = payload;
	},
};

const actions = {
	clearData({ commit }: any): void {
		commit('setUsers', []);
	},
	async getAllUsers({ commit }: any): Promise<void> {
		try {
			const getUsers = await axios({
				method: 'GET',
				url: process.env.VUE_APP_API_STAFF_URI + '/staff/users',
			});

			commit('setAllUsers', getUsers.data);
		} catch (e) {
			throw new Error(e.response.data.error);
		}
	},
	async getIncompleteUsers({ commit }: any): Promise<void> {
		try {
			const getUsers = await axios({
				method: 'GET',
				url: process.env.VUE_APP_API_STAFF_URI + '/staff/users?incomplete_users=true',
			});

			commit('setIncompleteUsers', getUsers.data);
		} catch (e) {
			throw new Error(e.response.data.error);
		}
	},
	async getUser({ commit }: any, sub: string): Promise<void> {
		try {
			const getUser = await axios({
				method: 'GET',
				url: process.env.VUE_APP_API_STAFF_URI + '/staff/users?sub=' + sub,
			});

			if (getUser.data.missing_coreusers === undefined) {
				getUser.data.missing_coreusers = false;
			}

			commit('setUser', getUser.data);
		} catch (e) {
			throw new Error(e.response.data.error);
		}
	},
};

export { state, getters, mutations, actions };
